import {PriceFormValidator} from '../../utils/validators'
import * as _ from "lodash";

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: {length?: number },
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            min?: number,
            coefficient?: number | null,
            error: any
        },
    }
}


const initialState: Form = {
    valid: false,
    data: {
        payment_type: {
            required: true,
            value: null,
            added: false,
            error: null
        },
        price: {
            required: true,
            value: null,
            added: false,
            error: null,
            coefficient: null
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const CaseForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'PRICE_FORM_ADD_CHANGE':
            return PriceFormValidator({...state.data}, action);
        case 'RESET_PRICE_FORM':
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default CaseForm;
